/**
 * Invoices Received - Módulo para la gestión de pagos recibidos
 */
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';
import 'select2';
import { getSpanishLanguage, moneyFormat } from '@/helpers';
export class PaymentsComplementsVendorTxt {
    constructor() {
        this.TABLE_ID = '#paymentsTable';
        this.dataTable = null;
        this.baseUrl = window.location.origin;
        this.init();
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeModule();
            });
        }
        else {
            this.initializeModule();
        }
    }
    initializeModule() {
        this.initializeTable();
        this.setupEventListeners();
    }
    setupEventListeners() {
        // Escuchar cambios de tema para ajustar la tabla si es necesario
        window.addEventListener('theme-changed', () => {
            this.adjustTableForTheme();
        });
    }
    adjustTableForTheme() {
        // Ajustes visuales cuando cambia el tema (si es necesario)
        if (this.dataTable) {
            this.dataTable.draw(false);
        }
    }
    initializeTable() {
        const tableElement = document.querySelector(this.TABLE_ID);
        if (!tableElement) {
            console.warn('Invoices table element not found');
            return;
        }
        try {
            this.dataTable = $(this.TABLE_ID).DataTable(this.getTableConfig());
        }
        catch (error) {
            console.error('Error initializing DataTables:', error);
        }
    }
    getTableConfig() {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        return {
            processing: true,
            serverSide: true,
            scrollX: true,
            language: getSpanishLanguage(),
            ajax: {
                url: `${this.baseUrl}/invoices_received/list-payments`,
                type: 'POST',
                data: {
                    'csrf_token': csrfToken || ''
                },
                error: (xhr, error, thrown) => {
                    console.error('Error al cargar los datos:', error);
                    const tbody = document.querySelector(`${this.TABLE_ID} tbody`);
                    if (tbody) {
                        tbody.innerHTML = '<tr><td colspan="9" class="text-center text-danger">Error al cargar los datos. Por favor, recargue la página.</td></tr>';
                    }
                }
            },
            columns: [
                {
                    data: 'id_payment_complements',
                    name: 'id_payment_complements',
                    className: 'text-nowrap text-center',
                    render: (data, type, row) => this.renderAcciones(row)
                },
                {
                    data: 'date_registered',
                    name: 'date_registered',
                    className: 'text-nowrap'
                },
                {
                    data: 'date_stamped',
                    name: 'date_stamped',
                    className: 'text-nowrap'
                },
                {
                    data: 'uuid',
                    name: 'uuid',
                    className: 'text-nowrap'
                },
                {
                    data: 'invoice_number_vendor',
                    name: 'invoice_number_vendor',
                    className: 'text-nowrap text-start'
                },
                {
                    data: 'tax_number',
                    name: 'tax_number',
                    className: 'text-nowrap'
                },
                {
                    data: 'tax_name',
                    name: 'tax_name',
                    className: 'text-nowrap'
                },
                {
                    data: 'related_uuid',
                    name: 'related_uuid',
                    className: 'text-nowrap',
                },
                {
                    data: 'partial',
                    name: 'partial',
                    className: 'text-nowrap',
                },
                {
                    data: 'imp_saldo_ant',
                    name: 'imp_saldo_ant',
                    className: 'text-nowrap',
                    render: (data) => moneyFormat(Number(data))
                },
                {
                    data: 'imp_pagado',
                    name: 'imp_pagado',
                    className: 'text-nowrap',
                    render: (data) => moneyFormat(Number(data))
                },
                {
                    data: 'imp_saldo_insoluto',
                    name: 'imp_saldo_insoluto',
                    className: 'text-nowrap',
                    render: (data) => moneyFormat(Number(data))
                },
                {
                    data: 'id_invoice_received',
                    name: 'id_invoice_received',
                    className: 'text-nowrap text-center',
                    render: (data) => this.renderStatus(data),
                },
                {
                    data: 'sftp_sended',
                    name: 'sftp_sended',
                    className: 'text-nowrap text-center',
                    render: (data) => this.renderSftpSended(data),
                },
            ],
            order: [{ name: 'date_registered', dir: 'desc' }],
            pageLength: 25,
            lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]]
        };
    }
    renderStatus(data) {
        return `
            <span
                class="badge bg-${data ? 'success' : 'danger'} cursor-pointer"
                title="${data ? 'Factura relacionada cargada y validada' : 'No se ha validado la factura relacionada'}">
                <i class="bi bi-${!data ? 'x-circle' : 'check-circle'}" aria-hidden="true"></i>
            </span>
        `;
    }
    renderSftpSended(data) {
        const dataNumber = Number(data);
        const isSended = !!dataNumber && dataNumber == 1;
        return `
            <span
                class="badge bg-${isSended ? 'success' : 'danger'} cursor-pointer"
                title="${isSended ? 'Enviado' : 'No enviado'}">
                <i class="bi bi-${!isSended ? 'x-circle' : 'check-circle'}" aria-hidden="true"></i>
            </span>
        `;
    }
    /**
     * Obtiene la instancia del DataTable
     */
    getTable() {
        return this.dataTable;
    }
    /**
     * Recarga los datos de la tabla
     * @param resetPaging Si es true, resetea la paginación a la primera página
     */
    reload(resetPaging = false) {
        if (this.dataTable) {
            this.dataTable.ajax.reload(null, resetPaging);
        }
    }
    /**
     * Filtra la tabla por una columna específica
     * @param column Índice de la columna
     * @param value Valor a buscar
     */
    filterByColumn(column, value) {
        if (this.dataTable) {
            this.dataTable.column(column).search(value).draw();
        }
    }
    /**
     * Limpia todos los filtros de la tabla
     */
    clearFilters() {
        if (this.dataTable) {
            this.dataTable.search('').columns().search('').draw();
        }
    }
    renderAcciones(row) {
        const { uuid, id_payment_complements: id, can_download_xml, } = row;
        let buttons = `
            <div class="btn-group" role="group">                
                ${can_download_xml ? `
                        <a href="${this.baseUrl}/invoices_received/download-payment-xml/${uuid}"
                        class="btn btn-sm btn-outline-primary"
                        title="Descargar XML de pago">
                            <i class="bi bi-filetype-xml"></i>
                        </a>` : ''}
        `;
        buttons += '</div>';
        ;
        return buttons;
    }
}
export default PaymentsComplementsVendorTxt;
